<template>
  <section class="top-ptable">
    <div class="top-ptable__header-container-ins">
      <template v-if="!isTeam"
        >Haz click en cualquier
        <template v-if="getUser.tournament == 1001"
          ><template v-if="category == 22">portera</template><template v-else>jugadora</template></template
        ><template v-else
          ><template v-if="category == 22">portero</template><template v-else>jugador</template></template
        ></template
      >
      <template v-else>Haz click en cualquier equipo </template>
    </div>
    <div class="top-ptable__header" :style="`background-color: #EDF4F9;`">
      <span :style="`color: ${customValues.color}`">POS</span>
      <span :style="`color: ${customValues.color}`">
        <template v-if="!isTeam"
          ><template v-if="getUser.tournament == 1001"
            ><template v-if="category == 22">PORTERA</template><template v-else>JUGADORA</template></template
          ><template v-else
            ><template v-if="category == 22">PORTERO</template><template v-else>JUGADOR</template></template
          ></template
        >
        <template v-else>EQUIPO</template>
      </span>
      <span :style="{ color: customValues.color, 'text-align': 'left;' }">TOTAL</span>
    </div>
    <div v-for="(player, i) in playerData" :key="i" class="top-ptable__row row-user">
      <span class="row-user__number"> {{ i + 1 + topValue * 10 }}. </span>
      <div class="row-user__info" @click="sendToProfile(player.id)">
        <img v-if="viewImage == indexPage" :src="player.img" :alt="player.name" />
        <span>{{ player.name }}</span>
      </div>
      <span class="row-user__total">
        <span class="row-user__total__item" @click="setOpenMedia(player.id)">{{ player.total }}</span>
      </span>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'PlayerTable',

  props: {
    playerData: {
      type: Array,
      required: true,
    },
    viewImage: {
      type: Number,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      require: true,
    },
    topValue: {
      type: Number,
      required: true,
    },
    indexPage: {
      type: Number,
      required: true,
    },
    customValues: {
      type: Object,
      default: () => {},
    },
    isTeam: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: [Object, Array],
      default: () => {},
    },
    season: {
      type: Number,
      default: 1401,
    },
    categoryName: {
      type: String,
      default: '',
    },
    objectCategory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('loginGeneral', [
      'getPremiumAccount',
      'getUser',
      'getTournamentSelected',
      'getSeasonSelected',
      'seasonId',
    ]),
    ...mapState('loginGeneral', ['tournamentsForMediaPlayer']),
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    setOpenMedia(player) {
      const seasonId = Number(this.getSeasonSelected || this.seasonId);
      const tournaments = this.tournamentsForMediaPlayer || new Map();
      if (this.categories.includes(12) && this.isTeam) {
        this.categories.push(...['54_r', '35_r']);
      }
      if (seasonId && tournaments.size === 0) {
        tournaments.set(seasonId, {
          _id: seasonId,
          id: seasonId,
          seasons: [
            {
              id: seasonId,
              related_seasons: [],
              type: 0,
            },
          ],
        });
      }
      let jsonConfig = {
        seasonId,
        tournaments,
        categoryIds: this.categories,
        mainSectionType: 1,
        playListType: this.isTeam ? 3 : 2,
        gameIds: null,
        matchResult: [1, 2, 3],
        advancedFilter: {
          playListTitle: this.categoryName,
          mainCategoryId: {},
          playingAs: this.filters.playingAs,
          timeSections: this.filters.sections,
          fieldSections: this.filters.zone,
          coordinatePoint: this.objectCategory.coordinatePoint,
        },
      };
      if (this.isTeam) {
        jsonConfig.playerIds = [];
        jsonConfig.teamId = player;
      } else {
        jsonConfig.playerIds = [player];
        jsonConfig.teamId = 0;
      }
      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
    sendToProfile(id) {
      let route = {};
      if (this.isTeam) {
        route = { name: 'team', params: { teamId: id } };
      } else {
        route = { name: 'player', params: { seasonId: this.getSeasonSelected, playerId: id } };
      }
      this.$router.push(route);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-ptable {
  width: 100%;
  margin-bottom: 10px;

  &__header-container-ins {
    margin-top: 0.2em;
    width: 100%;
    background: #fff;
    height: 32px;
    font-family: 'Circular-Std-Medium';
    color: #132839;
    font-size: 14px;
    text-align: center;
    line-height: 33px;
  }
  &__header,
  &__row {
    display: grid;
    grid-template-columns: minmax(25px, 30px) 1fr minmax(40px, 50px);
    border-radius: 2.4px;
    align-items: center;
  }
  &__row:nth-child(even) {
    background-color: #f5f5f5;
  }

  &__row:nth-child(odd) {
    background-color: #ffffff;
  }
  &__header {
    background-color: #dbefca;
    height: 24px;
    span {
      font-family: 'Avenir-Bold';
      font-size: 12px;
      font-weight: bold;
      letter-spacing: -0.18px;
      text-align: center;
      color: #353535;
    }
  }
}
.row-user {
  color: #545454;
  height: 38px;

  @media screen and (max-width: 500px) {
    margin: 0px 12px;
  }
  &__number {
    font-family: 'Avenir-Medium';
    font-size: 13.2px;
    font-weight: 500;
    letter-spacing: -0.49px;
  }
  &__info {
    font-family: 'Avenir-Medium';
    font-size: 13px;
    display: grid;
    align-items: center;
    grid-template-columns: 20px 1fr;
    column-gap: 10px;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    text-decoration: underline;
    color: #132839;
    white-space: nowrap;
  }
  &__info:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  &__total {
    font-family: 'Avenir-Bold';
    font-size: 13.2px;
    font-weight: bold;
    letter-spacing: -0.49px;
    text-align: center;
    padding-right: 15px;
    text-decoration: underline;
    @media screen and (max-width: 500px) {
      padding-left: 10px;
      padding-right: 0px;
    }
    &__item {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
        color: #00a5ff;
        text-decoration: underline;
      }
    }
  }
}
</style>
